import { createSelector } from '@ngrx/store';
import * as RA from 'ramda-adjunct';
import { getManagementState, ManagementState } from '../management.reducer';
import { adapter, ConsumerTypesState } from './consumer-types.reducer';
import {asyncActionState} from '@emm/core/util/async-action-state';
import {ConsumerType} from '@emm/core/models/consumer-type.model';
import {SearchFilter} from '@emm/core/models/search-filter';

const getState = createSelector(
    getManagementState,
    (state: ManagementState) => state.consumerTypes
);

const entitySelectors = adapter.getSelectors(getState);
const asyncActionStateSelectors = asyncActionState.getSelectors(getState);

const getSelectedTag = createSelector(getState, (state: ConsumerTypesState) => state.selectedTag);
const getSelected = createSelector(
    entitySelectors.selectEntities,
    getSelectedTag,
    (entities, selectedTag) => selectedTag && entities[selectedTag]
);
const getValidAll = createSelector(
    entitySelectors.selectAll,
    asyncActionStateSelectors.getHasError,
    asyncActionStateSelectors.getSuccess,
    (items, hasError, success) => (!hasError && success ? items : null)
);
const getSearchFilter = createSelector(getState, (state: ConsumerTypesState) => state.searchFilter);
const getFilteredItems = createSelector(
    getValidAll,
    getSearchFilter,
    (consumerTypes: ConsumerType[], filter: SearchFilter) => {
        const useFilter =
            RA.isNonEmptyArray(consumerTypes) &&
            RA.isNotNilOrEmpty(filter) &&
            RA.isNonEmptyString(filter.key) &&
            RA.isNotNil(filter.value);

        const filterString = (filter?.value as string)?.toLowerCase();

        const filteredItems = consumerTypes?.filter((item: ConsumerType) => {
            return item[filter?.key] && item[filter?.key].toLowerCase().includes(filterString);
        });

        return useFilter ? filteredItems : consumerTypes;
    }
);

export const ConsumerTypesSelectors = {
    entitySelectors,
    ...asyncActionStateSelectors,
    getSelected,
    getValidAll,
    getSearchFilter,
    getFilteredItems,
};
